export default {
  setUserSubscriptionDetails(
    state: { userSubscriptionDetails: any },
    value: any
  ) {
    state.userSubscriptionDetails = value;
  },
};
